import { _ as _copyObject } from './_copyObject.mjs';
import { k as keysIn_1 } from './keysIn.mjs';

var copyObject = _copyObject,
    keysIn = keysIn_1;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

var _baseAssignIn = baseAssignIn;

export { _baseAssignIn as _ };
